import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import {
  BanksApiBanksRequest,
  BankWrapperList,
  buildBanksApi,
} from "@rentablo/api/apiv1";
const getBanks = async (params: BanksApiBanksRequest) => {
  const banksApi = await buildBanksApi();
  const { data } = await banksApi.banks(params);
  return data;
};

export const useBanks = (
  options?: UseMutationOptions<
    BankWrapperList,
    AxiosApiError,
    BanksApiBanksRequest
  >
) => {
  return useMutation({
    mutationFn: getBanks,
    ...options,
  });
};
